import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getApplicationDetails, ApplicationDetailsDto } from "../api/services";
import ApplicationHeader from "../components/ApplicationHeader";
import PaymentForm from "../components/PaymentForm";

const PaymentPage: React.FC = () => {
  const { t } = useTranslation();
  const { id: applicationId } = useParams<{ id: string }>();

  const [application, setApplication] = useState<ApplicationDetailsDto | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorKey, setErrorKey] = useState<string | null>(null);
  const [showStripeForm, setShowStripeForm] = useState(false);

  useEffect(() => {
    if (!applicationId) return;

    setLoading(true);
    getApplicationDetails(applicationId)
      .then((res) => {
        setApplication(res.data);
        setErrorKey(null);
      })
      .catch((err) => {
        console.error(err);
        setErrorKey("application.errorLoadingDetails");
      })
      .finally(() => setLoading(false));
  }, [applicationId]);

  const handleContinue = () => {
    setShowStripeForm(true);
  };

  if (loading) {
    return <p>{t("application.loading", "Loading...")}</p>;
  }

  if (errorKey) {
    return <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-danger">{t(errorKey)}</div>;
  }

  if (!application) {
    return <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-danger">Application not found</div>;
  }

  return (
    <div>
      <h1 className="mb-6">{t("application.title")}</h1>

      <ApplicationHeader
        propertyName={application.unit.property.name}
        unitName={application.unit.name}
        moveInDate={new Date(application.createdAt).toLocaleDateString()}
      />

      {!showStripeForm ? (
        <div>
          <div className="text-center mb-6">
            {/* Credit card icon */}
            <div className="mb-4">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
              >
                <path
                  d="M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
                  fill="currentColor"
                />
              </svg>
            </div>

            <h3 className="mb-2">Verification Cost</h3>
            <div className="text-5xl text-primary mb-2">$21</div>
            <p className="text-muted mb-6">This is a one-time, non-refundable fee.</p>
            <p className="text-muted mb-6">
              <i>Required to continue</i>
            </p>

            <button
              className="rounded-lg bg-primary px-8 py-3 text-base font-medium text-white transition-colors hover:bg-primary-light"
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      ) : (
        <PaymentForm
          onBack={() => setShowStripeForm(false)}
          onSuccess={() => {
            // Payment was successful, redirect will be handled by PaymentForm
          }}
        />
      )}
    </div>
  );
};

export default PaymentPage;
